export default __webpack_public_path__ + "static/media/img-video-earn-royalties.42dcf9db.jpg";